import { useEffect, useMemo, useState } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";
import { useTheme } from "@mui/material/styles";

const ParticleBackground = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const [init, setInit] = useState(false);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    }).then(() => setInit(true));
  }, []);

  const options = useMemo(() => ({
    fullScreen: { enable: true, zIndex: 0 },
    background: { color: { value: "transparent" } },
    particles: {
      number: {
        value: 40,
        density: { enable: true, area: 800 },
      },
      color: {
        value: isDark ? "#1AAEFF" : "#0077cc",
      },
      links: {
        enable: false,
      },
      move: {
        enable: true,
        speed: 1.2,
        direction: "none" as const,
        outModes: { default: "bounce" as const },
      },
      size: {
        value: { min: 1, max: 3 },
      },
      opacity: {
        value: { min: 0.1, max: 0.4 },
      },
    },
    interactivity: {
      events: {
        onHover: {
          enable: false,
        },
      },
    },
    detectRetina: true,
  }), [isDark]);

  if (!init) return null;

  return (
    <Particles
      id="tsparticles"
      options={options}
    />
  );
};

export default ParticleBackground;
